import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-y', 'IconLetterY', [["path",{"d":"M7 4l5 9l5 -9","key":"svg-0"}],["path",{"d":"M12 13l0 7","key":"svg-1"}]]);